import { ReactElement } from 'react';
import { PAY_FRAME_NAME } from '../types';
import { OtherFieldContainer } from './OtherField/OtherFieldContainer';
import { PayFieldContainer } from './PayField/PayFieldContainer';
import { HealthCheckView } from './HealthCheck/HealthCheckView';

type MapReactComponent = () => ReactElement;

const viewFormMapData: ([
  string, 
  MapReactComponent,
])[] = [
  [PAY_FRAME_NAME, () => <PayFieldContainer />],
  ['', () => <HealthCheckView />],
];

const view: Map<string, MapReactComponent> = new Map(viewFormMapData);

export const getViewFieldComponent = (fieldType: string) => {
  const ViewComponent = view.get(fieldType);
  return ViewComponent ? ViewComponent() : <OtherFieldContainer />;
};
